import React from 'react'
import { VariantProps } from 'class-variance-authority'

import { tcva } from 'utils/tcva'
import { cn } from 'utils/cn'

export const COLORS = {
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  gray: 'bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  red: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  green: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  indigo: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
  purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
  pink: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-300',
  black: 'bg-black text-gray-300 dark:bg-gray-900 dark:text-gray-800',
  white: 'bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100',
}

export const badgeVariants = tcva([' text-xs px-2.5 py-0.5 rounded-xl'], {
  variants: {
    color: COLORS,
  },
})

type Props = {
  className?: string
} & ({ children?: undefined; label: string } | { children: React.ReactNode; label?: undefined })

export type BadgeVariants = VariantProps<typeof badgeVariants>

export const Badge = React.memo((props: Omit<BadgeVariants, keyof Props> & Props) => {
  return (
    <>
      <span className={cn(badgeVariants(props), props.className, 'capitalize')}>{props.label || props.children}</span>
    </>
  )
})
